import React, { useState } from 'react';

import { useTranslation } from 'react-i18next';

import { Icon, UiButton } from '@shared/ui';

import cls from './GenerateMeasurementButton.module.css';

interface GenerateMeasurementButtonProps {
    onOpenModel: () => void;
}

export const GenerateMeasurementButton = ({ onOpenModel }: GenerateMeasurementButtonProps) => {
    const { t } = useTranslation();
    const [isHover, setIsHover] = useState(false);
    return (
        <UiButton
            onMouseMove={() => setIsHover(true)}
            onMouseOut={() => setIsHover(false)}
            className={cls.generateMeasurementButton}
            onClick={onOpenModel}
            startIcon={
                <Icon iconName={isHover ? 'generateMeasurementRus' : 'generateMeasurement'} />
            }
            btnText={t('GenerateMeasurementButton.return.UiButton.btnText')}
        />
    );
};
